import { Children } from "../../lib/typeDeclarations";

type FormProps = {
  onSubmit: React.FormEventHandler<HTMLFormElement>;
  children: React.ReactNode;
};

export default function Form({ onSubmit, children }: FormProps) {
  return (
    <form onSubmit={onSubmit} autoComplete="off">
      {children}
    </form>
  );
}
